import React from 'react';
import get from 'lodash/get';
import Typography from '@material-ui/core/Typography';
import {
  defineMessages,
  FormattedHTMLMessage,
  FormattedMessage,
  injectIntl,
  intlShape,
} from 'react-intl';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import VISMA_DOC_STATUSES from '../../../constants/vismaDocStatuses';

import s from './SignatureStatus.scss';

const messages = defineMessages({
  pendingStatusMsg: {
    id: 'SignatureStatus.pendingStatusMsg',
    defaultMessage:
      'Digital Visma Sign Status: <b>Pending</b>, the invitation to sign the certificate was sent to <b>{signerEmail}</b> on <b>{signInvitationDate}</b',
  },
  canceledStatusMsg: {
    id: 'SignatureStatus.canceledStatusMsg',
    defaultMessage:
      'Digital Visma Sign Status: <b>Canceled</b>, <b>{signerEmail}</b> did not fulfill invitation to sign',
  },
});
const SignatureStatus = props => {
  const {
    cert: { vismaSign },
  } = props;
  if (!get(vismaSign, 'signerEmail')) {
    return null;
  }

  if (vismaSign.status === VISMA_DOC_STATUSES.pending) {
    return (
      <Typography className={s.signStatus} variant="subtitle1">
        {vismaSign.status === VISMA_DOC_STATUSES.pending && (
          <FormattedHTMLMessage
            {...messages.pendingStatusMsg}
            values={{
              signerEmail: vismaSign.signerEmail,
              signInvitationDate: moment(vismaSign.createDate).format(
                'YYYY-MM-DD',
              ),
            }}
          />
        )}
        {vismaSign.status === VISMA_DOC_STATUSES.cancelled && (
          <FormattedMessage
            {...messages.canceledStatusMsg}
            values={{ signerEmail: vismaSign.signerEmail }}
          />
        )}
      </Typography>
    );
  }

  return null;
};

SignatureStatus.propTypes = {
  cert: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  intl: intlShape.isRequired,
};

SignatureStatus.defaultProps = {};
export default compose(injectIntl, withStyles(s))(SignatureStatus);
